import {
    AssetAllocation,
    SingleStockSMAYesNo,
    DividendIncomeYesNo,
    InternationalEquitiesYesNo,
    PortfolioTilt
} from "./FormStages";
import React from "react";



export const getDefaultValues = ()=>{
    return {
        dividend: false,
        international: false,
        singleStock: false,
        equity: 80,
        fixed: 20,
        tilt: null
    }
}


export const generateFormStages = ({control, setValue, showInvestmentType})=>{
    const stages = [
        {
            name: 'Step 1',
            component: <AssetAllocation control={control} />,
            description: "Set Targets for Equities and Bonds",
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/vector-graphics/model-builder/target-allocations.svg'
        },
        {
            name: "Step 2",
            component: <DividendIncomeYesNo control={control} />,
            description: "Add Dividend Income Stock SMA?",
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/vector-graphics/model-builder/dividend-income.svg'
        },
        {
            name: "Step 3",
            component: <InternationalEquitiesYesNo control={control} />,
            description: "Add Option for Foreign Exposure",
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/vector-graphics/model-builder/foreign-allocation.svg'
        },
        {
            name: "Step 4",
            component: <SingleStockSMAYesNo control={control} />,
            description: "High Net Worth Stock SMA",
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/vector-graphics/model-builder/stock-sma.svg'
        },
        {
          name: "Step 5",
          component: <PortfolioTilt control={control} />,
          description: "Select Tilt Option",
          imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/vector-graphics/model-builder/portfolio-tilt.svg'
        },
  ].filter(Boolean);
    return stages;

}

